import { render, staticRenderFns } from "./DocsDetailEvent.vue?vue&type=template&id=cedf61ec&"
import script from "./DocsDetailEvent.vue?vue&type=script&lang=js&"
export * from "./DocsDetailEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports